import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Download } from "lucide-react";
import { Helmet } from "react-helmet-async";
import energyWhitepaperFull from "@/assets/energy-whitepaper-full.png.asset.json";

const WhitePaperEnergyIntro = () => {
  return (
    <>
      <Helmet>
        <title>From data to efficiency – Energy Optimization White Paper | Cetasol</title>
        <meta
          name="description"
          content="The fastest path to energy optimization in maritime operations. Learn how decision support, digital twins and AI turn vessel data into measurable efficiency gains."
        />
        <link rel="canonical" href="https://cetasol.com/energy-optimization-white-paper" />
        <meta property="og:title" content="From data to efficiency – Energy Optimization White Paper | Cetasol" />
        <meta property="og:description" content="The fastest path to energy optimization in maritime operations. Learn how decision support, digital twins and AI turn vessel data into measurable efficiency gains." />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://cetasol.com/energy-optimization-white-paper" />
        <meta property="og:image" content="https://cetasol.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="From data to efficiency – Energy Optimization White Paper | Cetasol" />
        <meta name="twitter:description" content="The fastest path to energy optimization in maritime operations. Learn how decision support, digital twins and AI turn vessel data into measurable efficiency gains." />
        <meta name="twitter:image" content="https://cetasol.com/og-image.jpg" />
      </Helmet>
      <Header />
      <main className="min-h-screen pt-24 pb-16">
        <article className="container mx-auto px-6 max-w-3xl">
          <Link
            to="/whitepapers"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8"
          >
            <ArrowLeft size={16} /> Back to all white papers
          </Link>

          <header className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              From data to efficiency: The fastest path to energy optimization in maritime operations
            </h1>
            <Link to="/whitepaper/energy-optimization-download" className="inline-block mt-6">
              <Button className="gap-2">
                <Download size={16} /> Download PDF
              </Button>
            </Link>
          </header>

          <img
            src={energyWhitepaperFull.url}
            alt="Energy Optimization White Paper cover"
            className="w-full rounded-lg mb-8"
          />

          <div className="prose prose-invert prose-lg max-w-none prose-p:text-foreground/80 prose-p:leading-relaxed prose-p:mb-4">
            <p>
              Energy optimization is about achieving more with less energy. Data alone does not improve performance, better decisions do.
            </p>
            <p>
              Decision support transforms operational data into actionable insight. Digital twins and AI help identify opportunities that would otherwise remain hidden, and small efficiency improvements can create significant fleet-wide value.
            </p>
            <p>
              Organizations that turn insight into action will be best positioned for the future. Download the full white paper to see how to take the fastest path to energy optimization across your fleet.
            </p>
          </div>

          <div className="mt-10 flex justify-center">
            <Link to="/whitepaper/energy-optimization-download">
              <Button className="gap-2">
                <Download size={16} /> Download PDF
              </Button>
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
};

export default WhitePaperEnergyIntro;
